<template>
  <PopModal ref="modal" :title="$t('进行评论')">
    <van-form @submit="onClickSend">
      <div class="modal-body">
        <div class="form-group">
          <label class="opacity-60">{{ $t("产品") }}</label>
          <p>{{ goodsName }}</p>
        </div>
        <div class="form-group">
          <label class="opacity-60">{{ $t("评分") }}</label>
          <div>
            <van-rate v-model="rating" />
          </div>
        </div>

        <div class="form-group">
          <label class="opacity-60">{{ $t("评论") }}</label>
          <textarea
            class="form-control"
            rows="4"
            name="content"
            :placeholder="$t('你的意见')"
            required=""
            v-model="content"
          />
        </div>
      </div>
      <div class="modal-footer">
        <van-button
          :loading="loading"
          :loading-text="$t('submitting')"
          class="btn btn-primary fw-600"
          native-type="submit"
          type="primary"
        >
          {{ $t("submit") }}
        </van-button>
        <button
          type="button"
          class="btn btn-sm btn-light"
          data-dismiss="modal"
          @click="onClickCancel"
        >
          {{ $t("取消") }}
        </button>
      </div>
    </van-form>
  </PopModal>
</template>
<script>
import PopModal from "@/components/PopModal.vue";

export default {
  components: {
    PopModal
  },
  data() {
    return {
      loading: false,
      orderItemId: null,
      goodsName: null,
      rating: 0,
      content: ""
    };
  },
  methods: {
    show(orderItemId, goodsName) {
      this.orderItemId = orderItemId;
      this.goodsName = goodsName;
      this.content = "";
      this.rating = 0;
      this.$refs.modal.show();
    },
    onClickCancel() {
      this.$refs.modal.hide();
    },
    onClickSend() {
      this.loading = true;
      this.$post("/user/goodsEvaluation/submit", {
        orderItemId: this.orderItemId,
        content: this.content,
        rating: this.rating
      })
        .then(() => {
          this.loading = false;
          this.content = null;
          this.$refs.modal.hide();
          this.$toast.success(this.$t("Commit_Success"));
          this.$emit("commentSuccess", this.orderItemId);
        })
        .catch(() => {
          this.loading = false;
          this.$toast.fail(this.$t("Commit_Success"));
        });
    }
  }
};
</script>
